export default __webpack_public_path__ + "assets/images/h-h1-icon-bf891e5d.svg";